export default __webpack_public_path__ + "static/media/upcomingdrop_almo.dccdaa91.png";